import { render } from "./LoginPanel.vue?vue&type=template&id=654856cc"
import script from "./LoginPanel.vue?vue&type=script&lang=ts"
export * from "./LoginPanel.vue?vue&type=script&lang=ts"
script.render = render

export default script